import React, { DetailedHTMLProps, useCallback, useEffect, useMemo, useRef } from "react"
import { FileInput } from "./FileInput"


const ImageInput = React.forwardRef<HTMLInputElement, Props>( ( { className: _className, onProccessImages, ...props }, ref ) => {

    const className = useMemo( () => {
        return [
            'w-full focus:outline-none h-12 border px-2',
            ...( _className?.split( ' ' ) ?? [] )
        ].join( ' ' )
    }, [ _className ] )

    const handleChange = useCallback( ( e:any ) => {
        const files = e.target?.files
        Promise.all( Array.from( files ?? [] ).map( async ( file:any )=> {
            return await new Promise<string>( ( res, rej ) => {
                const reader = new FileReader()
                reader.readAsDataURL( file )
                reader.onload = () => {
                    reader.result?.toString() && res( reader.result?.toString() )
                }
                reader.onerror = rej
            } )
        } ) ).then( onProccessImages ).catch( console.log )
    }, [ onProccessImages ] )

    const realRef = useRef<HTMLInputElement>( null ) || ref

    useEffect( () => {
        const el = realRef.current
        el?.addEventListener('change', handleChange )
        return () => {
            el?.removeEventListener('change', handleChange )
        }
    }, [ realRef, handleChange ] )

    return (
        <FileInput
            className={ className }
            ref={ realRef }
            type="file"
            accept="image/*"
            onChange={ handleChange }
            { ...props }
        />
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    onProccessImages?: ( urls:string[] ) => void
}

export { ImageInput }
